module.exports = __webpack_public_path__ + "static/media/Sugar Fairy.3e0adf90.jpg";